import React from "react";
import WrapperPage from "../../components/WrapperPage";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import BaseInput from "../../components/BaseInput";
import { useTranslation } from "react-i18next";
import FormHeader from "../../components/FormHeader";
import useMutateCopyData from "../../hooks/useMutateCopyData";
import Game from "../../store/Game";
import { copyText2, copyText3 } from "../../utils/constants";
import ROUTES from "../../utils/routes.js";
import "./style.scss";

export default function InvitePage() {
  const { t } = useTranslation();
  const { link, onLinkCopyHandle } = useController();
  const { navigateTo } = useCustomNavigate();
  const redirectToPersonalAcc = async () => {
    navigateTo(ROUTES.PERSONAL_ACCOUNT_PAGE);
  };

  useMutateCopyData(link, Game.game?.type === "DEMO" ? copyText3 : copyText2);
  return (
    <div className="invite-wrapper centering-page">
      <div className="invite-wrapper__steps invite-wrapper_position">
        <FormHeader
          title={t("invitePair.title")}
          titleClass="payment-page__title"
          subtitle={t("invitePair.subtitle")}
        />
        <div className="invite-wrapper__copy">
          <BaseInput
            id={`input-clipboard-target-1`}
            className="invite__info__link__input"
            value={link}
            type="copy"
            copyOnClick={onLinkCopyHandle}
          />
        </div>
        <BaseButton
          className="invite-wrapper__button"
          onClick={redirectToPersonalAcc}
        >
          {t("personal_acc.play")}
        </BaseButton>
      </div>
    </div>
  );
}
